import { OkModel } from './../../../../model/ok.model';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

export const RequestAction = createAction('[jetco-claim-amount ] get data', props<{ start: string, end: string }>());
export const ResponseAction = createAction('[jetco-claim-amount] set data', props<{ payload: number }>());

